import { Company } from './company';
import { Location } from './location';
import { Place } from './place';

// entity is a common name for place, location and company
export type EntityType = 'company' | 'location' | 'place';
export type Entity = Company | Location | Place;

export const isCompany = (b: Entity): b is Company => {
  return (b as Company).locations !== undefined;
};

export const isLocation = (b: Entity): b is Location => {
  return (b as Location).places !== undefined;
};

export const isPlace = (b: Entity): b is Place => {
  return (b as Place).location !== undefined;
};

export interface EntityShortInfo {
  id: number;
  uuid: string;
  hash: string;
  translations: EntityShortInfoTranslations;
}

interface EntityShortInfoTranslations {
  address: string;
  city: string;
  title: string;
}
